// extracted by mini-css-extract-plugin
export default {"Errors":"Errors-module__Errors__mRw9s"};